import { ReactNode } from "react";
import { View } from "./View";

export interface IExtendedLeftRightSectionProps {
  leftText: ReactNode;
  rightText: ReactNode;
  hasBorder: boolean;
  className?: string;
}

export const ExtendedLeftRightSection = (
  props: IExtendedLeftRightSectionProps
) => {
  return <View {...props} />;
};
